import styled from '@emotion/styled';
import { mediaQueries } from '../../../../style/global-style';

export const StyledTable = styled.table`
    width: 375px;
    height: 100%;
    display: inline-table;
    position: relative;
    border-collapse: collapse;

    /* width of the ship column kept as 100% for portrait-width of device */
    @media (max-width: 480px) {
        width: 100%;
    }

    colgroup {
        col:first-child {
            width: 60%;
            background-color: rgba(0, 53, 93, 0.7);
        }

        col:last-child {
            width: 40%;
            background-color: rgba(0, 53, 93, 0.9);
            @media ${mediaQueries.tabletAndUp} {
                background-color: rgba(0, 53, 93, 0.8);
            }
        }
    }

    thead th {
        font-weight: 600;
        font-size: ${(props) => props.theme.fontSize.headlineS};
        padding: ${(props) =>
            `${props.theme.spacing.extraLarge} ${props.theme.spacing.medium} ${props.theme.spacing.extraLarge} ${props.theme.spacing.extraLarge}`};
        @media ${mediaQueries.tabletAndUp} {
            font-size: ${(props) => props.theme.fontSize.headlineM};
        }
        @media ${mediaQueries.allDesktop} {
            padding: ${(props) =>
                `${props.theme.spacing.xxxLarge} ${props.theme.spacing.medium} ${props.theme.spacing.extraLarge} ${props.theme.spacing.xxxLarge}`};
        }
    }

    tbody th {
        padding: ${(props) =>
            `${props.theme.spacing.small} ${props.theme.spacing.medium} ${props.theme.spacing.small} ${props.theme.spacing.extraLarge}`};
        font-weight: 500;

        @media ${mediaQueries.allDesktop} {
            padding: ${(props) =>
                `${props.theme.spacing.small} ${props.theme.spacing.medium} ${props.theme.spacing.small} ${props.theme.spacing.xxxLarge}`};
        }
    }

    /* make it aligned with IE as well */
    tr th,
    tr td {
        text-align: left;
    }

    /* adding separators */
    tr:not(:last-child) {
        th,
        td {
            position: relative;
        }

        th::after,
        td::after {
            content: '';
            border-bottom: 1px solid rgba(216, 216, 216, 0.08);
            position: absolute;
            bottom: 0;
            width: calc(100% - ${(props) => props.theme.spacing.extraLarge});
            @media ${mediaQueries.allDesktop} {
                width: calc(100% - ${(props) => props.theme.spacing.xxxLarge});
            }
        }

        th::after {
            left: ${(props) => props.theme.spacing.extraLarge};
            @media ${mediaQueries.allDesktop} {
                left: ${(props) => props.theme.spacing.xxxLarge};
            }
        }
        td::after {
            left: 0;
        }
    }

    font-size: ${(props) => props.theme.fontSize.copyTextXL};

    tbody {
        tr:last-child {
            td,
            th {
                padding-bottom: ${(props) => props.theme.spacing.extraLarge};

                @media ${mediaQueries.allDesktop} {
                    padding-bottom: ${(props) => props.theme.spacing.xxxLarge};
                }
            }
        }

        td {
            color: ${(props) => props.theme.shades.lightGrey};
            padding: ${(props) =>
                `${props.theme.spacing.small} ${props.theme.spacing.extraLarge} ${props.theme.spacing.small} ${props.theme.spacing.extraLarge}`};

            @media ${mediaQueries.allDesktop} {
                padding: ${(props) =>
                    `${props.theme.spacing.small} ${props.theme.spacing.xxxLarge} ${props.theme.spacing.small} ${props.theme.spacing.extraLarge}`};
            }
        }
    }
`;

export const StyledShipColumnWrapper = styled.div`
    max-width: 1170px;
    height: 100%;
    @media ${mediaQueries.tabletAndUp} {
        margin-left: 40px;
    }
    @media ${mediaQueries.desktopAndUp} {
        margin: 0 auto;
    }
`;
